import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Teleport as _Teleport } from "vue";
const _hoisted_1 = { style: { "display": "flex", "align-items": "center" } };
const _hoisted_2 = {
    key: 0,
    style: { "margin-left": "10px" }
};
const _hoisted_3 = { style: { "display": "flex", "align-items": "center" } };
const _hoisted_4 = {
    key: 0,
    style: { "margin-left": "10px" }
};
const _hoisted_5 = { class: "flex justify-between items-center pr-3 -m-2" };
import MediaUpload from '@/components/MediaUpload.vue';
import { appState } from '@/composable/appState';
import { CHAT_WIDGET_IDS, ChatType, ChatWidgetSettingsDataOptions, acknowledgementIconsLiveChatOptions, acknowledgementIconsOptions, } from '@/helper/const';
import { isImageStorageUrl, updateChatWidgetSetting } from '@/helper/helper';
import { i18n } from '@/plugin/vue-i18n';
import { ImagePlusIcon } from '@gohighlevel/ghl-icons/24/outline';
import { UIAvatar, UIButton, UICard, UIColorPicker, UIFormItem, UIInput, UIRadioGroup, UIRadioGroupItem, UISpace, UITextSmRegular, } from '@gohighlevel/ghl-ui';
import { computed, ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'AcknowledgementMessage',
    setup(__props) {
        const openMediaPicker = ref(false);
        const imageUrl = ref();
        const handleEdit = () => (openMediaPicker.value = true);
        const closeMediaPicker = () => (openMediaPicker.value = false);
        const updateAcknowledgementIconImage = (val) => {
            if (val) {
                imageUrl.value = val;
                appState.chatWidgetSettingsData.acknowledgementDetails.icon = imageUrl.value;
                imageUrl.value = '';
                appState.unsavedChanges = true;
            }
        };
        const handleReplaceImage = () => {
            appState.chatWidgetSettingsData.acknowledgementDetails.icon =
                acknowledgementIconsOptions[0].value;
            appState.unsavedChanges = true;
        };
        const updateAcknowledgementColor = (val) => {
            appState.chatWidgetSettingsData.acknowledgementDetails.placeholderColor = val;
            appState.unsavedChanges = true;
        };
        const updateAcknowledgementIcon = (val) => {
            appState.chatWidgetSettingsData.acknowledgementDetails.icon = val;
            appState.unsavedChanges = true;
        };
        const isAckIconImage = computed(() => {
            var _a, _b;
            return isImageStorageUrl((_b = (_a = appState.chatWidgetSettingsData) === null || _a === void 0 ? void 0 : _a.acknowledgementDetails) === null || _b === void 0 ? void 0 : _b.icon);
        });
        return (_ctx, _cache) => {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (((_a = _unref(appState).chatWidgetSettingsData) === null || _a === void 0 ? void 0 : _a.chatType) !== _unref(ChatType).LIVE_CHAT)
                    ? (_openBlock(), _createBlock(_unref(UIFormItem), {
                        key: 0,
                        label: _ctx.$t('sidebar.customerSupportContact'),
                        "show-feedback": false,
                        class: "my-2"
                    }, {
                        default: _withCtx(() => {
                            var _a;
                            return [
                                _createVNode(_unref(UIInput), {
                                    type: "text",
                                    id: _unref(CHAT_WIDGET_IDS).CHAT_WIDGET_LABEL_INPUT,
                                    modelValue: (_a = _unref(appState).chatWidgetSettingsData) === null || _a === void 0 ? void 0 : _a.supportContact,
                                    placeholder: _unref(i18n).global.t('placeholder.supportContact'),
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] =
                                        val => _unref(updateChatWidgetSetting)(_unref(ChatWidgetSettingsDataOptions).SUPPORT_CONTACT, val))
                                }, null, 8 /* PROPS */, ["id", "modelValue", "placeholder"])
                            ];
                        }),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["label"]))
                    : _createCommentVNode("v-if", true),
                (((_b = _unref(appState).chatWidgetSettingsData) === null || _b === void 0 ? void 0 : _b.chatType) !== _unref(ChatType).LIVE_CHAT)
                    ? (_openBlock(), _createBlock(_unref(UIFormItem), {
                        key: 1,
                        label: _ctx.$t('sidebar.acknowledgementMessage'),
                        "show-feedback": false,
                        class: "my-2"
                    }, {
                        default: _withCtx(() => {
                            var _a;
                            return [
                                _createVNode(_unref(UIInput), {
                                    rows: 4,
                                    type: "textarea",
                                    id: _unref(CHAT_WIDGET_IDS).CHAT_WIDGET_LABEL_INPUT,
                                    modelValue: (_a = _unref(appState).chatWidgetSettingsData) === null || _a === void 0 ? void 0 : _a.successMsg,
                                    placeholder: _unref(i18n).global.t('placeholder.successMsg'),
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] =
                                        val => _unref(updateChatWidgetSetting)(_unref(ChatWidgetSettingsDataOptions).SUCCESS_MSG, val))
                                }, null, 8 /* PROPS */, ["id", "modelValue", "placeholder"])
                            ];
                        }),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["label"]))
                    : _createCommentVNode("v-if", true),
                (((_c = _unref(appState).chatWidgetSettingsData) === null || _c === void 0 ? void 0 : _c.chatType) === _unref(ChatType).LIVE_CHAT)
                    ? (_openBlock(), _createBlock(_unref(UIFormItem), {
                        key: 2,
                        label: _ctx.$t('sidebar.acknowledgementMessage'),
                        "show-feedback": false,
                        class: "my-2"
                    }, {
                        default: _withCtx(() => {
                            var _a;
                            return [
                                _createVNode(_unref(UIInput), {
                                    rows: 4,
                                    type: "textarea",
                                    id: _unref(CHAT_WIDGET_IDS).CHAT_WIDGET_LABEL_INPUT,
                                    modelValue: (_a = _unref(appState).chatWidgetSettingsData) === null || _a === void 0 ? void 0 : _a.liveChatAckMsg,
                                    placeholder: _unref(i18n).global.t('placeholder.successMsg'),
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] =
                                        val => _unref(updateChatWidgetSetting)(_unref(ChatWidgetSettingsDataOptions).LIVE_CHAT_ACK_MSG, val))
                                }, null, 8 /* PROPS */, ["id", "modelValue", "placeholder"])
                            ];
                        }),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["label"]))
                    : _createCommentVNode("v-if", true),
                (((_d = _unref(appState).chatWidgetSettingsData) === null || _d === void 0 ? void 0 : _d.chatType) === _unref(ChatType).EMAIL_CHAT ||
                    ((_e = _unref(appState).chatWidgetSettingsData) === null || _e === void 0 ? void 0 : _e.chatType) === _unref(ChatType).WA_CHAT)
                    ? (_openBlock(), _createBlock(_unref(UIFormItem), {
                        key: 3,
                        label: _ctx.$t('sidebar.acknowledgementGreeting'),
                        "show-feedback": false,
                        class: "my-2"
                    }, {
                        default: _withCtx(() => {
                            var _a;
                            return [
                                _createVNode(_unref(UIInput), {
                                    rows: 4,
                                    type: "textarea",
                                    id: _unref(CHAT_WIDGET_IDS).CHAT_WIDGET_LABEL_INPUT,
                                    modelValue: (_a = _unref(appState).chatWidgetSettingsData) === null || _a === void 0 ? void 0 : _a.thankYouMsg,
                                    placeholder: _unref(i18n).global.t('placeholder.thankYouMsg'),
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] =
                                        val => _unref(updateChatWidgetSetting)(_unref(ChatWidgetSettingsDataOptions).THANK_YOU_MSG, val))
                                }, null, 8 /* PROPS */, ["id", "modelValue", "placeholder"])
                            ];
                        }),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["label"]))
                    : _createCommentVNode("v-if", true),
                (((_f = _unref(appState).chatWidgetSettingsData) === null || _f === void 0 ? void 0 : _f.chatType) === _unref(ChatType).LIVE_CHAT)
                    ? (_openBlock(), _createBlock(_unref(UIFormItem), {
                        key: 4,
                        label: _ctx.$t('sidebar.feedbackMessage'),
                        "show-feedback": false,
                        class: "my-2"
                    }, {
                        default: _withCtx(() => {
                            var _a;
                            return [
                                _createVNode(_unref(UIInput), {
                                    rows: 4,
                                    type: "textarea",
                                    id: _unref(CHAT_WIDGET_IDS).CHAT_WIDGET_LABEL_INPUT,
                                    modelValue: (_a = _unref(appState).chatWidgetSettingsData) === null || _a === void 0 ? void 0 : _a.liveChatFeedbackMsg,
                                    placeholder: _unref(i18n).global.t('placeholder.thankYouMsg'),
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] =
                                        val => _unref(updateChatWidgetSetting)(_unref(ChatWidgetSettingsDataOptions).LIVE_CHAT_FEEDBACK_MSG, val))
                                }, null, 8 /* PROPS */, ["id", "modelValue", "placeholder"])
                            ];
                        }),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["label"]))
                    : _createCommentVNode("v-if", true),
                (((_g = _unref(appState).chatWidgetSettingsData) === null || _g === void 0 ? void 0 : _g.chatType) === _unref(ChatType).LIVE_CHAT)
                    ? (_openBlock(), _createBlock(_unref(UIFormItem), {
                        key: 5,
                        label: _ctx.$t('sidebar.feedbackSubmissionNote'),
                        "show-feedback": false,
                        class: "my-2"
                    }, {
                        default: _withCtx(() => {
                            var _a;
                            return [
                                _createVNode(_unref(UIInput), {
                                    rows: 4,
                                    type: "textarea",
                                    id: _unref(CHAT_WIDGET_IDS).CHAT_WIDGET_LABEL_INPUT,
                                    modelValue: (_a = _unref(appState).chatWidgetSettingsData) === null || _a === void 0 ? void 0 : _a.liveChatFeedbackNote,
                                    placeholder: _unref(i18n).global.t('placeholder.liveChatFeedbackNote'),
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] =
                                        val => _unref(updateChatWidgetSetting)(_unref(ChatWidgetSettingsDataOptions).LIVE_CHAT_FEEDBACK_NOTE, val))
                                }, null, 8 /* PROPS */, ["id", "modelValue", "placeholder"])
                            ];
                        }),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["label"]))
                    : _createCommentVNode("v-if", true),
                (((_h = _unref(appState).chatWidgetSettingsData) === null || _h === void 0 ? void 0 : _h.chatType) === _unref(ChatType).LIVE_CHAT)
                    ? (_openBlock(), _createBlock(_unref(UIFormItem), {
                        key: 6,
                        label: _ctx.$t('sidebar.chatEndedMessage'),
                        "show-feedback": false,
                        class: "my-2"
                    }, {
                        default: _withCtx(() => {
                            var _a;
                            return [
                                _createVNode(_unref(UIInput), {
                                    rows: 4,
                                    type: "textarea",
                                    id: _unref(CHAT_WIDGET_IDS).CHAT_WIDGET_LABEL_INPUT,
                                    modelValue: (_a = _unref(appState).chatWidgetSettingsData) === null || _a === void 0 ? void 0 : _a.liveChatEndedMsg,
                                    placeholder: _unref(i18n).global.t('placeholder.liveChatEndedMsg'),
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] =
                                        val => _unref(updateChatWidgetSetting)(_unref(ChatWidgetSettingsDataOptions).LIVE_CHAT_ENDED_MSG, val))
                                }, null, 8 /* PROPS */, ["id", "modelValue", "placeholder"])
                            ];
                        }),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["label"]))
                    : _createCommentVNode("v-if", true),
                (_unref(appState).chatWidgetSettingsData.chatType !== _unref(ChatType).LIVE_CHAT)
                    ? (_openBlock(), _createBlock(_unref(UIFormItem), {
                        key: 7,
                        label: _ctx.$t('sidebar.acknowledgementIcon'),
                        "show-feedback": false,
                        class: "my-2"
                    }, {
                        default: _withCtx(() => {
                            var _a, _b;
                            return [
                                _createVNode(_unref(UIRadioGroup), {
                                    value: (_b = (_a = _unref(appState).chatWidgetSettingsData) === null || _a === void 0 ? void 0 : _a.acknowledgementDetails) === null || _b === void 0 ? void 0 : _b.icon,
                                    name: "AcknowledgementIconOptions",
                                    "onUpdate:value": _cache[7] || (_cache[7] = val => updateAcknowledgementIcon(val))
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_unref(UISpace), null, {
                                            default: _withCtx(() => {
                                                var _a, _b;
                                                return [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(acknowledgementIconsOptions), (item) => {
                                                        return (_openBlock(), _createBlock(_unref(UIRadioGroupItem), {
                                                            key: item.value,
                                                            value: item.value,
                                                            compact: true,
                                                            class: "p-2"
                                                        }, {
                                                            icon: _withCtx(() => [
                                                                (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), { class: "w-6 h-6" }))
                                                            ]),
                                                            _: 2 /* DYNAMIC */
                                                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["value"]));
                                                    }), 128 /* KEYED_FRAGMENT */)),
                                                    _createElementVNode("div", _hoisted_1, [
                                                        (_openBlock(), _createBlock(_unref(UIAvatar), {
                                                            key: _unref(isAckIconImage),
                                                            id: _unref(CHAT_WIDGET_IDS).CHAT_WIDGET_AVATAR,
                                                            size: 42,
                                                            objectFit: "fill",
                                                            round: true,
                                                            src: _unref(isAckIconImage)
                                                                ? (_b = (_a = _unref(appState).chatWidgetSettingsData) === null || _a === void 0 ? void 0 : _a.acknowledgementDetails) === null || _b === void 0 ? void 0 : _b.icon
                                                                : null,
                                                            onClick: handleEdit
                                                        }, {
                                                            default: _withCtx(() => [
                                                                (!_unref(isAckIconImage))
                                                                    ? (_openBlock(), _createBlock(_unref(ImagePlusIcon), {
                                                                        key: 0,
                                                                        class: "w-4 h-4"
                                                                    }))
                                                                    : _createCommentVNode("v-if", true)
                                                            ]),
                                                            _: 1 /* STABLE */
                                                        }, 8 /* PROPS */, ["id", "src"])),
                                                        (_unref(isAckIconImage))
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                                                                _createVNode(_unref(UIButton), {
                                                                    id: _unref(CHAT_WIDGET_IDS).CHAT_WIDGET_MEDIA_UPLOADER,
                                                                    type: "error",
                                                                    text: true,
                                                                    onClick: handleReplaceImage
                                                                }, {
                                                                    default: _withCtx(() => [
                                                                        _createTextVNode(_toDisplayString(_ctx.$t('sidebar.remove')), 1 /* TEXT */)
                                                                    ]),
                                                                    _: 1 /* STABLE */
                                                                }, 8 /* PROPS */, ["id"])
                                                            ]))
                                                            : _createCommentVNode("v-if", true)
                                                    ])
                                                ];
                                            }),
                                            _: 1 /* STABLE */
                                        })
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["value"])
                            ];
                        }),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["label"]))
                    : _createCommentVNode("v-if", true),
                (_unref(appState).chatWidgetSettingsData.chatType === _unref(ChatType).LIVE_CHAT)
                    ? (_openBlock(), _createBlock(_unref(UIFormItem), {
                        key: 8,
                        label: _ctx.$t('sidebar.acknowledgementIcon'),
                        "show-feedback": false,
                        class: "my-2"
                    }, {
                        default: _withCtx(() => {
                            var _a, _b;
                            return [
                                _createVNode(_unref(UIRadioGroup), {
                                    value: (_b = (_a = _unref(appState).chatWidgetSettingsData) === null || _a === void 0 ? void 0 : _a.acknowledgementDetails) === null || _b === void 0 ? void 0 : _b.icon,
                                    name: "AcknowledgementIconOptions",
                                    "onUpdate:value": _cache[8] || (_cache[8] = val => updateAcknowledgementIcon(val))
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_unref(UISpace), null, {
                                            default: _withCtx(() => {
                                                var _a, _b;
                                                return [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(acknowledgementIconsLiveChatOptions), (item) => {
                                                        return (_openBlock(), _createBlock(_unref(UIRadioGroupItem), {
                                                            key: item.value,
                                                            value: item.value,
                                                            compact: true,
                                                            class: "p-2"
                                                        }, {
                                                            icon: _withCtx(() => [
                                                                (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), { class: "w-6 h-6" }))
                                                            ]),
                                                            _: 2 /* DYNAMIC */
                                                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["value"]));
                                                    }), 128 /* KEYED_FRAGMENT */)),
                                                    _createElementVNode("div", _hoisted_3, [
                                                        (_openBlock(), _createBlock(_unref(UIAvatar), {
                                                            key: _unref(isAckIconImage),
                                                            id: _unref(CHAT_WIDGET_IDS).CHAT_WIDGET_AVATAR,
                                                            size: 42,
                                                            objectFit: "fill",
                                                            round: true,
                                                            src: _unref(isAckIconImage)
                                                                ? (_b = (_a = _unref(appState).chatWidgetSettingsData) === null || _a === void 0 ? void 0 : _a.acknowledgementDetails) === null || _b === void 0 ? void 0 : _b.icon
                                                                : null,
                                                            onClick: handleEdit
                                                        }, {
                                                            default: _withCtx(() => [
                                                                (!_unref(isAckIconImage))
                                                                    ? (_openBlock(), _createBlock(_unref(ImagePlusIcon), {
                                                                        key: 0,
                                                                        class: "w-4 h-4"
                                                                    }))
                                                                    : _createCommentVNode("v-if", true)
                                                            ]),
                                                            _: 1 /* STABLE */
                                                        }, 8 /* PROPS */, ["id", "src"])),
                                                        (_unref(isAckIconImage))
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                                                                _createVNode(_unref(UIButton), {
                                                                    id: _unref(CHAT_WIDGET_IDS).CHAT_WIDGET_MEDIA_UPLOADER,
                                                                    type: "error",
                                                                    text: true,
                                                                    onClick: handleReplaceImage
                                                                }, {
                                                                    default: _withCtx(() => [
                                                                        _createTextVNode(_toDisplayString(_ctx.$t('sidebar.remove')), 1 /* TEXT */)
                                                                    ]),
                                                                    _: 1 /* STABLE */
                                                                }, 8 /* PROPS */, ["id"])
                                                            ]))
                                                            : _createCommentVNode("v-if", true)
                                                    ])
                                                ];
                                            }),
                                            _: 1 /* STABLE */
                                        })
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["value"])
                            ];
                        }),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["label"]))
                    : _createCommentVNode("v-if", true),
                _createVNode(_unref(UICard), null, {
                    default: _withCtx(() => {
                        var _a, _b;
                        return [
                            _createElementVNode("div", _hoisted_5, [
                                _createVNode(_unref(UITextSmRegular), null, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('sidebar.placeholderColor')), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                }),
                                _createVNode(_unref(UIColorPicker), {
                                    value: (_b = (_a = _unref(appState).chatWidgetSettingsData) === null || _a === void 0 ? void 0 : _a.acknowledgementDetails) === null || _b === void 0 ? void 0 : _b.placeholderColor,
                                    "onUpdate:value": _cache[9] || (_cache[9] = val => updateAcknowledgementColor(val)),
                                    compact: true,
                                    modes: ['hex', 'rgb']
                                }, null, 8 /* PROPS */, ["value"])
                            ])
                        ];
                    }),
                    _: 1 /* STABLE */
                }),
                (_openBlock(), _createBlock(_Teleport, { to: 'body' }, [
                    (openMediaPicker.value)
                        ? (_openBlock(), _createBlock(MediaUpload, {
                            key: 0,
                            allowedExtensions: ['image'],
                            openMediaPicker: openMediaPicker.value,
                            onClose: closeMediaPicker,
                            onChangeUrl: _cache[10] || (_cache[10] = val => updateAcknowledgementIconImage(val)),
                            maxUploadSize: 10000000
                        }, null, 8 /* PROPS */, ["openMediaPicker"]))
                        : _createCommentVNode("v-if", true)
                ]))
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
